import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FilePond, registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';
import {maxSizeAllFilesInMegaBytes} from '../../../../common/constants/ftr';
import Loader from '../../../../common/components/loader';
import {formValueSelector} from 'redux-form';
import {MASTER_VEHICLE_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
// import './references.scss';
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize, FilePondPluginFileRename);
export const MAXFILESIZE = `${maxSizeAllFilesInMegaBytes}MB`;
class References extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'katashiki': '',
      'sfx': '',
      'fileName': '',
    };
  }
  onDownloadFile = (position) => {
    const {rowImages, katashiki, sfx, saveVehicleFileAudi} = this.props;
    const fileInBase64 = rowImages[position].file;
    const filename = rowImages[position].name;
    const pdfs = atob(fileInBase64);
    const len = pdfs.length;
    const bytes = new Uint8Array(len);
    this.setState({'fileName': filename, 'katashiki': katashiki, 'sfx': sfx}, () => {
      const data = {...this.state};
      saveVehicleFileAudi({data});
    });
    for (let i = 0; i < len; i++) {
      bytes[i] = pdfs.charCodeAt(i);
    }
    this.saveDowloadedData(bytes.buffer, filename);
  };
  saveDowloadedData = (data, filename) => {
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const blob = new Blob([data], {'type': 'octet/stream'});
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  };
  render() {
    const {images, rowImages, imagesLoading, addService, addImport, handleChangeImages} = this.props;
    if (imagesLoading) {
      return (
        <div className="twc-loader-subcontracts">
          <Loader />
        </div>
      );
    }
    if (addImport) {
      return (
        <div className='warranty-container-references'>
          {rowImages ?
            rowImages.map((file, idx) => (
              <p
                key={idx}
                style={{'textAlign': 'center'}}
                className='link'
                onClick={() => this.onDownloadFile(idx)}
              >
                {file.name}
              </p>
            )) : (
              <div className='warranty-container-references'>
                <h3>No se encuentran adjuntos disponibles</h3>
              </div>
            )}
        </div>
      );
    }
    if (addService) {
      return (
        <div className='warranty-container-references'>
          <FilePond
            maxFileSize={MAXFILESIZE}
            disabled={!addService}
            allowDownload={addService}
            files={images}
            allowMultiple={true}
            onupdatefiles={(fileItems) => handleChangeImages(fileItems)}
            labelIdle='Arrastrar archivo o <span class="filepond--label-action">Navegador</span>'
          />
        </div>
      );
    }
    return (
      <div className="twc-loader-subcontracts">
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const formValues = formValueSelector(MASTER_VEHICLE_FORM.name);
  const katashiki = formValues(state, 'katashiki');
  const sfx = formValues(state, 'sfx');
  return {
    'rowImages': state.masterVehicleImages.rowImages,
    'images': state.masterVehicleImages.images,
    'imagesLoading': state.masterVehicleImages.imagesLoading,
    'code': ownProps.params.vehCode,
    katashiki,
    sfx,
    
  };
};
const {
  saveVehicleFileAudi,
} = Actions;
export default connect(mapStateToProps, {saveVehicleFileAudi})(References);
